import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Logo } from '../logo/logo';
import { Store } from '@ngxs/store';
import { LoadingState } from '../../../core/loading.state';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { Clipboard, ClipboardModule } from '@angular/cdk/clipboard';
import { MatIconModule } from '@angular/material/icon';
import { ToastService } from '../../../core/toast.service';
import { APP_CONTACT_US_EMAIL } from '../../shared/constants';
import { AuthState } from '../../auth/auth-state';
import { AuthLogin, AuthLogOut } from '../../auth/auth-action';
import { ChatRoutingModule } from '../../chat/chat-routing-module';
import { Router } from '@angular/router';
import { LayoutState } from '../../../core/layout.state';

@Component({
  selector: 'app-toolbar',
  imports: [
    MatToolbarModule,
    Logo,
    MatProgressBarModule,
    MatMenuModule,
    MatButtonModule,
    ClipboardModule,
    MatIconModule,
    ChatRoutingModule,
  ],
  templateUrl: './app-toolbar.html',
  styleUrl: './app-toolbar.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppToolbar {
  #store = inject(Store);
  loading$ = this.#store.selectSignal(LoadingState.loadingAll);
  clipboard = inject(Clipboard);
  toastService = inject(ToastService);
  #router = inject(Router);
  isMd$ = this.#store.selectSignal(LayoutState.isXsm);

  email = APP_CONTACT_US_EMAIL;
  isLoggedIn$ = this.#store.selectSignal(AuthState.isLoggedIn);

  @Input() showHomeNavigationRoutes: boolean = false;
  @Input({ required: true }) addExtraSpacing!: boolean;
  @Input({ required: true }) showMenu: boolean = false;
  @Input() menuOpened!: boolean;
  @Output() menuOpenedChange = new EventEmitter<boolean>();

  copyEmail() {
    this.clipboard.copy(this.email);
    this.toastService.showToast(`copied: ${this.email}`);
  }

  logout() {
    this.#store.dispatch(new AuthLogOut());
  }

  login() {
    this.#store.dispatch(new AuthLogin());
  }

  openDashboard() {
    return this.#router.navigateByUrl('/portal/chat/new');
  }
}
